export function generateColor(decimalNumber) {
  return decimalNumber.toString(16);
}

export function getRandomColor() {
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);
  const color = [r, g, b];
  return color;
}
export function getpast() {
  const store = localStorage.getItem("allScore");
  if (store === null) {
    localStorage.setItem("allScore", "[]");
    return [];
  }
  return JSON.parse(store);
}

/*

*/
